import { bl_svc_doc_event_RowCLass } from '../../../dbschema/bl_svc_doc_event.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceDocEventContainerModel extends BaseContainerModel {
  bl_svc_doc_event: bl_svc_doc_event_RowCLass = new bl_svc_doc_event_RowCLass();
}
